import styled from "styled-components";

export const RootContainer = styled.div`
	.infinite-scroll-component__outerdiv {
		height: calc(100vh - 70px);
	}

	.infinite-scroll-component {
		height: 100% !important;
		overflow-x: hidden !important;
	}
`;

export const HistoryBox = styled.div`
	display: flex;
	flex-direction: column;
	padding: 16px 20px;
	gap: 8px;
	&:nth-child(even) {
		background-color: #e1f0ff; /* Set your even background color here */
	}
`;

export const DateAndAmountContainer = styled.div`
	display: flex;
	flex-direction: row;
`;
export const Date = styled.p`
	flex-grow: 1;
	text-align: left;
	color: #000000;
	font-size: 15px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
`;
export const Amount = styled.p`
	color: #004f9c;
	text-align: right;
	font-size: 15px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
`;

export const Time = styled.p`
	color: #686b6e;
	/* font-family: Plus Jakarta Sans; */
	font-size: 12px;
	font-style: normal;
	font-weight: 300;
	line-height: 15px;
`;

export const ExpireBox = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: start;
	align-items: center;
	gap: 4px;
`;

export const ExpireText = styled.p`
	color: #c11909;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 15.92px; /* 107.692% */
`;

export const ExpiredTime = styled.p`
	color: #969696;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 14px; /* 107.692% */
`;

export const SpinWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: ${(props) =>
		props.size === "large" ? "calc(100vh - 70px)" : "auto"};
`;

export const EmptyText = styled.div`
	/* height: calc(100vh - 70px);
	align-items: center;
	justify-content: center;
	display: flex;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal; */
	color: #000000;
`;

export const EmptyWrapper = styled.div`
	width: 100%;
	height: 660px;
	gap: 10px;
	flex-direction: column;
	display: flex;
	justify-content: center;
	align-items: center;
`;
